import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {useTranslation} from "react-i18next";
import ColorPicker from "../../color-picker";
import {RENDERER_TYPES} from "../constants";

export const ColorPickerTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.colorPicker);

export const ColorPickerRenderer = withJsonFormsControlProps(({label, data, handleChange, path, schema}) => {
  const {t} = useTranslation();

  const colorFormat = schema?.colorFormat || "rgba";
  return (
    <div style={{marginBottom: "16px"}}>
      <ColorPicker
        value={data}
        onChange={newColor => handleChange(path, newColor)}
        label={label}
        dialogTitle={t("components.custom-json-forms.ColorPickerRenderer.dialogTitle")}
        colorFormat={colorFormat}
        className="custom-json-forms__renderers__color-picker"
      />
    </div>
  );
});
